import React, { useEffect, useState } from 'react';

import { ControlLabel } from 'react-bootstrap';
import styled from 'styled-components';

import { Activity, Category, SubCategory } from '../../../../types/Activity';
import SimpleSelect from '../../../utils/FormWidgets/SimpleSelect';
import { useFetchData } from '../../../../infrastructure/hooks/useFetchData';
import * as ActivitiesService from '../../../../services/ActivitiesService';
import { ApiStatus } from '../../../../infrastructure/constants/apiStatus';

const StyledContainer = styled.div`
  width: 300px;
  margin-bottom: 15px;
`;

type Props = {
  activity: Partial<Activity>;
  onSave(key: string, value?: string): void;
};

const clearSubCategoryOption = { id: '', name: 'Clear Sub-Category' };
const sortByName = (a: { name: string }, b: { name: string }) =>
  a.name.localeCompare(b.name);

const CategorySelector = ({ activity, onSave }: Props) => {
  const [apiStatus, categories, fetchCategories] = useFetchData<Category[]>();
  const [subCategoryOptions, setSubCategoryOptions] = useState<SubCategory[]>(
    []
  );

  useEffect(() => {
    fetchCategories(ActivitiesService.listCategories);
  }, []);

  useEffect(() => {
    const category = (categories || [])
      .sort(sortByName)
      .find(cat => cat.id === activity.categoryId);
    if (!category) {
      setSubCategoryOptions([]);
      return;
    }

    const subCategories = [...category.subCategories.sort(sortByName)];
    if (activity.subCategoryId) subCategories.unshift(clearSubCategoryOption);

    setSubCategoryOptions(subCategories);
  }, [activity, categories]);

  return (
    <StyledContainer>
      <ControlLabel>{'Category*'}</ControlLabel>
      <SimpleSelect
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        onChange={categoryId => {
          onSave(categoryId, undefined);
        }}
        value={activity.categoryId}
        name='categoryId'
        data={(categories || []).map(v => ({
          label: `${v.name}`,
          value: v.id,
        }))}
        placeholder={`${apiStatus === ApiStatus.loading ? 'Loading...' : ''}`}
        style={{ marginBottom: 15 }}
      />

      <ControlLabel>{'Sub-Category (Optional)'}</ControlLabel>
      <SimpleSelect
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        onChange={subCategoryId => {
          if (activity.categoryId) {
            onSave(activity.categoryId, subCategoryId);
          }
        }}
        value={activity.subCategoryId}
        name='subCategoryId'
        data={subCategoryOptions.map(v => ({
          label: `${v.name}`,
          value: v.id,
        }))}
      />
    </StyledContainer>
  );
};

export default CategorySelector;
